/** Which graph the Graph route shows: tickets and their links, or milestones and their order. */
export type GraphView = 'tickets' | 'milestones';

/** The `mode` URL value that selects the milestones graph. Any other value is the ticket graph. */
export const MILESTONES_GRAPH_MODE = 'milestones';

const LABELS: Record<GraphView, string> = { tickets: 'Tickets', milestones: 'Milestones' };

export function GraphViewSwitch({ view, onChange }: { view: GraphView; onChange: (view: GraphView) => void }) {
  return (
    <div className="graph-mode graph-view-switch" role="group" aria-label="Graph view">
      {(['tickets', 'milestones'] as const).map((option) => (
        <button
          type="button"
          key={option}
          className={view === option ? 'is-active' : ''}
          aria-pressed={view === option}
          onClick={() => { if (view !== option) onChange(option); }}
        >
          {LABELS[option]}
        </button>
      ))}
    </div>
  );
}
